type IntervalBoundary = {
  min: number;
  max: number;
  classification?: string;
};

// Prescription pixels depend on boundaries and classifications, not rates or areas.
export const getIntervalBoundaryKey = (intervals: IntervalBoundary[]): string =>
  JSON.stringify(intervals.map(({ min, max, classification }) => [min, max, classification]));
